import React, { useState } from 'react';
import { observer } from 'mobx-react';
import {
    Heading1,
    TextInput,
    ThemedButton,
    TextDefault,
    FlexDiv, InputLabel,
} from '@awarego-ui/components';
import pluralize from 'pluralize';
import { Input } from 'reactstrap';
import { Box, FormControl, FormHelperText } from '@mui/material';

function ChangeDuration({ onRequestClose, duration, saveChanges }) {
    const [minutesInput, setMinutesInput] = useState(String(duration));

    const handleSubmit = (event) => {
        event.preventDefault();
        const numericValue = Number(minutesInput);
        if (!isNaN(numericValue) && numericValue > 0) {
            saveChanges(numericValue);
            onRequestClose();
        }
    };

    const parsedMinutes = Number(minutesInput);
    const isValid = !isNaN(parsedMinutes) && parsedMinutes > 0;

    return (
        <div className="modalWindow simple">
            <form onSubmit={handleSubmit}>
                <div className="modalHeader plain">
                    <Heading1>Change duration</Heading1>
                    <img
                        className="modal-close-right"
                        src="/static/img/close.svg"
                        alt="Close"
                        onClick={onRequestClose}
                    />
                </div>
                <div style={{ minHeight: '100px', padding: '20px'}}>
                    <FlexDiv
                        gap={8}
                        justifyCenter
                        style={{ alignItems: 'baseline' }}
                    >
                        <TextInput
                            type="text"
                            id="duration"
                            name="duration"
                            value={minutesInput}
                            onChange={(e) => setMinutesInput(e.target.value)}
                            autoFocus
                            error={!isValid}
                            style={{width: '52px'}}
                            inline
                        />
                        <label htmlFor="duration">
                            {pluralize('minute', parsedMinutes || 0)}
                        </label>
                    </FlexDiv>
                </div>
                <div className="modalFooter">
                    <FlexDiv pr={40}>
                        <TextDefault
                            uppercase
                            extraBold
                            link
                            onClick={onRequestClose}
                        >
                            Cancel
                        </TextDefault>
                    </FlexDiv>
                    <ThemedButton
                        type="submit"
                        mode="primary"
                        disabled={!isValid}
                        text="Confirm"
                    />
                </div>
            </form>
        </div>
    );
}

export default observer(ChangeDuration);
